import React from 'react';
import PageHero from '../components/PageHero';
import PeriodicalsSection from '../components/sections/PeriodicalsSection';
import { useTranslation } from '../i18nContext';

export default function PeriodicalsPage() {
  const t = useTranslation();
  const locale = t.locale;
  return (
    <>
      <PageHero
        label={locale === 'es' ? 'Biblioteca' : 'Library'}
        title="Periodicals"
        subtitle={locale === 'es' ? 'Archivo de publicaciones del Colegio Mexicano de Intérpretes de Conferencias' : 'Publication archive of the Mexican College of Conference Interpreters'}
      />
      <PeriodicalsSection />
    </>
  );
}
